import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment-timezone'

import { Dropdown } from '../dropdown/dropdown.component'

const Datepicker = ({
  className,
  value,
  numberOfDays,
  onChange,
  onBlur,
  maxHeight,
  currentDay,
  showToday,
  dataTestid,
  i18n = {},
}) => {
  const timezone = i18n.timezone || moment.tz.guess()
  const locale = i18n.locale || Datepicker.defaultProps.i18n.locale
  const dateFormat = i18n.dateFormat || Datepicker.defaultProps.i18n.dateFormat
  const selectableDatesFromTomorrow = numberOfDays

  const currentDate = moment(currentDay || moment().format(), moment.ISO_8601)
    .tz(timezone)
    .locale(locale)
    .set({ h: 0, m: 0, s: 0, ms: 0 })
  const tomorrowDate = currentDate.clone().add(1, 'day')

  const todayOption = {
    label: i18n.today || currentDate.format(dateFormat),
    value: currentDate.format(),
  }
  const tomorrowOption = {
    label: i18n.tomorrow || tomorrowDate.format(dateFormat),
    value: tomorrowDate.format(),
  }
  const futureSelectableDates = [...new Array(selectableDatesFromTomorrow)].map(
    (_, index) => {
      const date = tomorrowDate.clone().add(index + 1, 'day')
      return { label: date.format(dateFormat), value: date.format() }
    }
  )

  const options = [
    ...(showToday ? [todayOption] : []),
    tomorrowOption,
    ...futureSelectableDates,
  ]
  const defaultOption = options[0]

  if (typeof value === 'undefined' || value === null) {
    setTimeout(() => onChange && onChange(defaultOption))
  }

  useEffect(() => {
    const optionMatchingValueProp = options.find(
      option => option.value === value
    )
    if (optionMatchingValueProp) {
      setTimeout(() => onChange && onChange(optionMatchingValueProp))
    } else {
      setTimeout(() => onChange && onChange(defaultOption))
    }
  }, [])

  return (
    <Dropdown
      className={className}
      defaultOptions={options}
      value={value || defaultOption}
      maxHeight={maxHeight}
      onChange={onChange}
      onBlur={onBlur}
      dataTestid={dataTestid}
    />
  )
}

Datepicker.propTypes = {
  className: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
    }),
    PropTypes.string,
  ]),
  numberOfDays: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  maxHeight: PropTypes.number,
  currentDay: PropTypes.string,
  showToday: PropTypes.bool,
  dataTestid: PropTypes.string,
  i18n: PropTypes.shape({
    today: PropTypes.string,
    tomorrow: PropTypes.string,
    dateFormat: PropTypes.string,
    timezone: PropTypes.string,
    locale: PropTypes.string,
  }),
}

Datepicker.displayName = 'Datepicker'

Datepicker.defaultProps = {
  showToday: true,
  numberOfDays: 5,
  maxHeight: 300,
  i18n: {
    dateFormat: 'MMM D, YYYY',
    locale: 'en',
  },
}

export { Datepicker }
